import { resolve } from 'rsvp';
import RESTAdapter from '@ember-data/adapter/rest';

// eslint-disable-next-line ember/no-classic-classes
export default RESTAdapter.extend({
  hasLoadedAll: false,
  namespace: '/api/v1/rest/external',
  shouldBackgroundReloadRecord() {
    return false;
  },
  shouldBackgroundReloadAll() {
    return false;
  },
  shouldReloadAll() {
    return !this.hasLoadedAll;
  },
  pathForType() {
    return 'employee_roles';
  },
  async findAll(...args) {
    const result = await this._super(...args);
    this.set('hasLoadedAll', true);
    return result;
  },
  updateRecord(store, type, snapshot) {
    if (snapshot.adapterOptions?.preventSave) {
      return resolve();
    } else {
      throw new Error('Employee roles should be saved as permission sets, instead of being saved through the model');
    }
  },
  createRecord(store, type, snapshot) {
    if (snapshot.adapterOptions?.preventSave) {
      return resolve();
    } else {
      throw new Error('Employee roles should be created as permission sets, instead of being saved through the model');
    }
  },
  queryRecord(store, type, {
    isTeamPermissions
  }) {
    if (isTeamPermissions !== true) {
      throw new Error('Querying for employee roles is only supported for fetching the team permissions role');
    }
    const existingTeamPermissions = store.peekAll(type.modelName).find(record => record.isGuestRole);
    if (existingTeamPermissions) {
      return resolve({
        employee_role: {
          token: existingTeamPermissions.token
        }
      });
    }

    // Using 'guest' as the id retrieves the team permissions role.
    const url = this.buildURL(type.modelName, 'guest');
    return this.ajax(url, 'GET');
  }
});